import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { rupee, waLink, productWaText } from "@/lib/whatsapp";
import { Heart, ShoppingBag, Star, MessageCircle } from "lucide-react";

export function ProductCard({ product }) {
  const { addToCart, toggleWishlist, inWishlist, settings } = useApp();
  const wished = inWishlist(product.id);
  const out = product.stock <= 0;

  return (
    <div className="group bg-white rounded-2xl overflow-hidden soft-shadow hover:soft-shadow-lg transition-shadow duration-300 flex flex-col" data-testid={`product-card-${product.id}`}>
      <Link to={`/product/${product.slug}`} className="relative block aspect-square overflow-hidden bg-sand">
        <img src={product.images?.[0]} alt={product.name} loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        {product.discount > 0 && (
          <span className="absolute top-3 left-3 bg-yellow text-ink text-xs font-700 px-2.5 py-1 rounded-full shadow-sm">{product.discount}% OFF</span>
        )}
        {out && <span className="absolute top-3 left-3 bg-brown/80 text-white text-xs font-500 px-2.5 py-1 rounded-full">Out of Stock</span>}
        <button onClick={(e) => { e.preventDefault(); toggleWishlist(product); }} data-testid={`wishlist-btn-${product.id}`}
          className="absolute top-3 right-3 w-9 h-9 rounded-full bg-cream/90 backdrop-blur flex items-center justify-center hover:bg-white transition-colors">
          <Heart className={`w-4 h-4 ${wished ? "fill-terracotta text-terracotta" : "text-forest"}`} />
        </button>
      </Link>
      <div className="p-4 flex flex-col flex-1">
        <div className="flex items-center justify-between mb-1">
          <span className="text-[11px] uppercase tracking-wide text-olive font-500">{product.brand}</span>
          <span className="inline-flex items-center gap-1 text-xs text-brown"><Star className="w-3 h-3 fill-mustard text-mustard" />{product.rating || "New"}</span>
        </div>
        <Link to={`/product/${product.slug}`} className="font-500 text-ink leading-snug line-clamp-2 hover:text-terracotta transition-colors min-h-[2.6rem]">{product.name}</Link>
        <span className="text-xs text-muted-foreground mt-1">{product.pack_size}</span>
        <div className="flex items-end gap-2 mt-2">
          <span className="text-lg font-700 text-orange">{rupee(product.price)}</span>
          {product.mrp > product.price && <span className="text-sm text-muted-foreground line-through">{rupee(product.mrp)}</span>}
        </div>
        <div className="mt-3 flex items-center gap-2">
          <button onClick={() => addToCart(product)} disabled={out} data-testid={`add-cart-btn-${product.id}`}
            className="flex-1 inline-flex items-center justify-center gap-1.5 bg-orange text-white text-sm font-600 rounded-full h-10 hover:bg-[#e65f00] disabled:opacity-40 transition-colors">
            <ShoppingBag className="w-4 h-4" /> Add
          </button>
          <a href={waLink(settings.whatsapp_number, productWaText(product))} target="_blank" rel="noreferrer" data-testid={`wa-btn-${product.id}`}
            className="w-10 h-10 rounded-full bg-[#25D366] flex items-center justify-center hover:bg-[#1eb85a] transition-colors shrink-0" title="Send on WhatsApp">
            <MessageCircle className="w-4 h-4 text-white" />
          </a>
        </div>
      </div>
    </div>
  );
}
